export const environment = {
  production: true,
  build: '2024610'
};
